import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const forceApi = createApi({
  reducerPath: "forceApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getForces: builder.query({
      query: (params) => ({
        url: "force/",
        params,
      }),
    }),
    createForce: builder.mutation({
      query: (newForce) => ({
        url: "force/",
        method: "POST",
        body: newForce,
      }),
    }),
    deleteForce: builder.mutation({
      query: (id) => ({
        url: `force/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetForcesQuery,
  useCreateForceMutation,
  useDeleteForceMutation,
} = forceApi;